import { EssityColumnProps } from '@components/shared/paginatedEssityTable/GridHelper';
import PaginatedEssityTable from '@components/shared/paginatedEssityTable/PaginatedEssityTable';
import { SieveModel } from '@components/shared/paginatedEssityTable/SieveModels';
import { TableWithTitle } from '@components/shared/TableWithTitle';
import { getEssityApiClient } from '@services/EssityApi';
import {
	AccountGetAllPharmacyUsersOptionalParams,
	AccountPharmacyUserDto,
	PharmacyAllByPortalUserOptionalParams,
	PharmacyDto,
} from '@services/src/models';
import React from 'react';

import { PortalAccountsTableColumn } from './PortalAccountsTableColumn';
import { GetPortalAccountsTableExpandedColumn } from './PortalAccountsTableExpandedColumn';
import styles from './styles/PortalAccountManagment.module.less';

export const PortalAccountsTable = () => {
	const tableColumns: EssityColumnProps<AccountPharmacyUserDto>[] = [
		...PortalAccountsTableColumn,
	];

	const expandedTableColumns: EssityColumnProps<PharmacyDto>[] = [
		...GetPortalAccountsTableExpandedColumn(),
	];

	return (
		<TableWithTitle title="Pharmacy User Accounts">
			<PaginatedEssityTable<AccountPharmacyUserDto>
				columns={tableColumns}
				gridName="pharmacy-user"
				hidePersonalizationSettings={true}
				getRowKey={(r: AccountPharmacyUserDto) => r.id!}
				getPagedResult={async (sieve: SieveModel, abortSignal) => {
					const parameters: AccountGetAllPharmacyUsersOptionalParams = {
						page: sieve.page,
						pageSize: sieve.pageSize,
						sorts: sieve.sorts,
						abortSignal: abortSignal,
						filters: sieve.filters,
					};

					const api = await getEssityApiClient();
					return await api.account.getAllPharmacyUsers(parameters);
				}}
				expandedRowRender={(record: AccountPharmacyUserDto) => (
					<PaginatedEssityTable<PharmacyDto>
						className={styles.portalAccountManagment}
						columns={expandedTableColumns}
						gridName="pharmacies"
						hidePersonalizationSettings={true}
						getRowKey={(r: PharmacyDto) => r.id!}
						detailsUrl="pharmacies/details"
						getPagedResult={async (
							sieve: SieveModel,
							abortSignal
						) => {
							const parameters: PharmacyAllByPortalUserOptionalParams = {
								page: sieve.page,
								pageSize: sieve.pageSize,
								sorts: sieve.sorts,
								abortSignal: abortSignal,
								filters: sieve.filters,
								portalUserId: record.id,
							};

							const api = await getEssityApiClient();
							return await api.pharmacy.allByPortalUser(
								parameters
							);
						}}
					/>
				)}
			/>
		</TableWithTitle>
	);
};
